import Debug from 'debug';
import { err, ok, Result } from '@xlearn/common'
import { delay } from './delay'
import { CancelToken } from './cancel-token'

export type WaitToLoadError = 'canceled' | 'timeout'

const debug = Debug('wait-to-load')

export async function waitToLoad(isLoaded: () => boolean,
                                 cancelToken: CancelToken | undefined = undefined,
                                 options: {delayMs: number, timeoutMs: number} =  { delayMs: 40, timeoutMs: 0 }
                                ): Promise<Result<true, WaitToLoadError>> {

  cancelToken = cancelToken || { cancel: false }
  
  const start = new Date()
  while (!isLoaded()) {
    await delay(options.delayMs)
    if (cancelToken.cancel) {
      debug('canceled')
      return err('canceled')
    }

    const now = new Date()
    if (options.timeoutMs > 0 && (now.getTime() - start.getTime() >= options.timeoutMs)) {
      debug('timeout')
      return err('timeout')
    }
  }

  return ok(true as true)
}
